import { ApexOptions } from "apexcharts"
import { useMemo } from "react"
import ReactApexChart from "react-apexcharts"
import { ApexChartType } from "src/shared/config/DefaultApexOptions"
import { totalOnHoverTooltip } from "../../../chartTooltip"
import { monitorApexOptions } from "../../../chartDateAxis"
const AUDIENCE_COLORS = [
  "#0064E0", "#E60023", "#34A853", "#833AB4", "#FF6D00",
  "#0077B5", "#D81B60", "#00ACC1", "#7CB342", "#F4511E",
]

export const SpendByAudience = ({ series }: ApexOptions) => {
  const spendByAudienceOptions = useMemo<ApexOptions>(
    () =>
      monitorApexOptions(
        {
          chart: {
            stacked: true,
          },
          yaxis: {
            labels: {
              formatter: function (y) {
                return `$${y.toFixed(0)}`
              },
            },
          },
          colors: AUDIENCE_COLORS,
          // §4.5: the day's combined total alongside the per-ad-group breakdown.
          tooltip: { shared: true, intersect: false, custom: totalOnHoverTooltip("currency") },
        },
        ApexChartType.bar,
      ),
    [],
  )

  return (
    <div>
      <ReactApexChart
        options={spendByAudienceOptions}
        series={series}
        type="bar"
        height={400}
      />
    </div>
  )
}
